import { useEffect } from "react";

function upsertMeta(name, content, property = false) {
  if (!content) return;
  const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    if (property) element.setAttribute("property", name);
    else element.setAttribute("name", name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let element = document.head.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
}

export function useTransportPublicSeo(seoBundle) {
  useEffect(() => {
    if (!seoBundle?.metadata) return undefined;

    const { metadata, structuredData } = seoBundle;
    const previousTitle = document.title;
    document.title = metadata.title || previousTitle;

    upsertMeta("description", metadata.description);
    upsertMeta("robots", metadata.robots);
    upsertLink("canonical", metadata.canonicalUrl);
    upsertMeta("og:title", metadata.openGraph?.title, true);
    upsertMeta("og:description", metadata.openGraph?.description, true);
    upsertMeta("og:url", metadata.openGraph?.url, true);
    upsertMeta("og:type", metadata.openGraph?.type || "website", true);
    if (metadata.openGraph?.image) {
      upsertMeta("og:image", metadata.openGraph.image, true);
    }
    upsertMeta("twitter:card", metadata.twitter?.card || "summary_large_image");
    upsertMeta("twitter:title", metadata.twitter?.title);
    upsertMeta("twitter:description", metadata.twitter?.description);

    const scriptId = "transport-public-jsonld";
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement("script");
      script.id = scriptId;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(structuredData || []);

    return () => {
      document.title = previousTitle;
    };
  }, [seoBundle]);
}

export function trackTransportPublicEvent(eventType, metadata = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent("midpoint:transport-public-analytics", {
      detail: { eventType, metadata, occurredAt: new Date().toISOString() },
    })
  );
}
